import Button from '@material-ui/core/Button';
import React, { useContext, useEffect, useState, useRef } from 'react';

import AddIcon from '@material-ui/icons/Add';
import { toast } from 'react-toastify';
import { deleteDegree, getDegree } from '../../../../actions/configuration';
import { LangCtx } from "../../../../lib/context";
import Loader from '../../../../lib/ui/loader/Loader';
import NoData from "../../../../lib/ui/nodata/NoData";
import "../../../../ui-styles/list/contactListAction.css";
import "../../../../ui-styles/search/Search.css";
import useDebounce from '../../../common/useDebounce';
import CreateDegree from './CreateDegree';
import DegreeCard from './degeeCard';



const Degrees = () =>
{
    const [ open, setOpen ] = useState(false);
    const [ degreeList, setDegreeList ] = useState([]);
    const [ count, setCount ] = useState(0);
    const [ loading, setLoading ] = useState(false);
    const [ searchTerm, setSearchTerm ] = useState('');
    const debouncedSearchTerm = useDebounce(searchTerm, 500);
    const searchRef = useRef('');
    const [ page, setPage ] = useState(0);
    let itemsPerPage = 5;
    const { l } = useContext(LangCtx);
    let query = `?limit=${itemsPerPage}&skip=${page}`;

    if (searchTerm)
    {
        query += `&searchKey=${searchTerm}`;
    }

    const handleClickOpen = () =>
    {
        setOpen(true);
    };

    const handleClose = (stat = false) =>
    {
        if (stat === true)
        {
            setPage(0);
            getDegreeData();
        }
        setOpen(false);
    };

    const getDegreeData = () =>
    {
        setLoading(true);
        getDegree(query).then((res) =>
        {
            if (res.status)
            {
                setCount(res.count);
                if (page === 0)
                {
                    setDegreeList(res?.data);
                } else
                {
                    setDegreeList((prev) => [ ...prev, ...res.data ]);
                }
            } else
            {
                setDegreeList([]);
                setCount(0);
            }
            setLoading(false);
        }).catch((err) =>
        {
            toast.error(err?.response?.data?.error, {
                position: toast.POSITION.TOP_RIGHT
            });
            setLoading(false);
            setCount(0);
        });
    };

    const handleDelete = (id) =>
    {
        setLoading(true);
        deleteDegree(id).then((res) =>
        {
            if (res.status)
            {
                toast.success(l.deg_del, {
                    position: toast.POSITION.TOP_RIGHT
                });
                setPage(0);
                // setOpenDelOpen(false);
                getDegreeData();
            } else
            {
                console.log('error');
            }
            setLoading(false);
        }).catch((err) =>
        {
            toast.error(err?.response?.data?.error, {
                position: toast.POSITION.TOP_RIGHT
            });
            setLoading(false);
        });
    };

    useEffect(() =>
    {
        if (searchRef.current !== searchTerm)
        {
            searchRef.current = searchTerm;
            setPage(0);
            getDegreeData();
        }
    }, [ debouncedSearchTerm ]);

    useEffect(() =>
    {
        getDegreeData();
    }, [ page ]);

    const handleLoadMore = () =>
    {
        setPage((prev) => prev + 1);
    };

    return (
        <>
            <div className='flexCol pos-rel'>
                {loading && <Loader />}
                <div className='resColRow pdngMD'>
                    <div className='flexMinWidthCol'>
                        <span className='topHdngTxt'>{l.degrees_list}</span>
                        <span className='lightTxt'>{l.below_list_ofDegrees_created}</span>
                    </div>
                    <div className='flexAutoRow alignRight resMobPdng'>
                        <Button variant="contained" color="primary" className='whiteTxt' onClick={handleClickOpen}>
                            <AddIcon />{l.create_degrees}
                        </Button>
                    </div>
                </div>
                <div className="searchCntnr">
                    <div className="searchBox searchFull">
                        <div className="searchForm">
                            <input className="textbox" type="text" placeholder={l.plc_search}
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                    </div>
                </div>
                {degreeList?.length > 0 ? <>
                    <div className='flexWrap inlineBlock pdngHztSM'>
                        {degreeList?.map((item) => (
                            <div className="flexCol inlineBlock4 pdngXS" key={item._id}>
                                <DegreeCard item={item} handleDelete={handleDelete} setPage={setPage} loadData={getDegreeData} />
                            </div>
                        )
                        )}
                    </div>
                    {(degreeList.length !== count) && <div className='flexRow alignCenter justifyCenter mrgnTopXS'><Button variant='contained' color='primary' onClick={handleLoadMore}>Load More</Button></div>}
                </> : !loading ? <NoData src='/images/file-icons/blank-file.png' Heading={l.nodeg_found} label={l.nodegdesc_found} /> : ''
                }
            </div>
            {open && <CreateDegree open={open} handleClose={handleClose} />}
        </>
        // </div >

    );
};

export default Degrees;